/**
 * Bonscan Clarification API
 * OpenAPI contract for Bonscan clarification endpoints consumed by client applications.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Assigned } from './assigned';
import { Trace } from './trace';


export interface Clarification { 
    id: string;
    keyCode?: string | null;
    keyCodeType?: string | null;
    bonID?: string | null;
    externalStoreID?: string | null;
    dateTime?: string | null;
    total?: number | null;
    imagePath?: string | null;
    status: Clarification.StatusEnum;
    declineReason?: Clarification.DeclineReasonEnum | null;
    assigned?: Assigned | null;
    traces?: Array<Trace> | null;
    updatedAt: string;
    createdAt: string;
}
export namespace Clarification {
    export type StatusEnum = 'OPEN' | 'LOCKED' | 'IN_PROGRESS' | 'DECLINED' | 'RESOLVED';
    export const StatusEnum = {
        Open: 'OPEN' as StatusEnum,
        Locked: 'LOCKED' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Declined: 'DECLINED' as StatusEnum,
        Resolved: 'RESOLVED' as StatusEnum
    };
    export type DeclineReasonEnum = 'NO_STORE_OF_OCM' | 'NO_BON' | 'BON_NOT_READABLE' | 'BON_TOO_OLD' | 'BON_DOUBLET' | 'FRAUD_SUSPICIOUS' | 'BON_DATA_MISSING' | 'NOT_METZINGEN_STORE' | 'BON_COPY' | 'CARD_RECEIPT' | 'DISPLAY_PHOTO' | 'DATE_NOT_AVAILABLE' | 'STORE_NOT_AVAILABLE' | 'AMOUNT_NOT_AVAILABLE' | 'SALE_NOT_ELIGIBLE' | 'ONLINESHOP_ORDER';
    export const DeclineReasonEnum = {
        NoStoreOfOcm: 'NO_STORE_OF_OCM' as DeclineReasonEnum,
        NoBon: 'NO_BON' as DeclineReasonEnum,
        BonNotReadable: 'BON_NOT_READABLE' as DeclineReasonEnum,
        BonTooOld: 'BON_TOO_OLD' as DeclineReasonEnum,
        BonDoublet: 'BON_DOUBLET' as DeclineReasonEnum,
        FraudSuspicious: 'FRAUD_SUSPICIOUS' as DeclineReasonEnum,
        BonDataMissing: 'BON_DATA_MISSING' as DeclineReasonEnum,
        NotMetzingenStore: 'NOT_METZINGEN_STORE' as DeclineReasonEnum,
        BonCopy: 'BON_COPY' as DeclineReasonEnum,
        CardReceipt: 'CARD_RECEIPT' as DeclineReasonEnum,
        DisplayPhoto: 'DISPLAY_PHOTO' as DeclineReasonEnum,
        DateNotAvailable: 'DATE_NOT_AVAILABLE' as DeclineReasonEnum,
        StoreNotAvailable: 'STORE_NOT_AVAILABLE' as DeclineReasonEnum,
        AmountNotAvailable: 'AMOUNT_NOT_AVAILABLE' as DeclineReasonEnum,
        SaleNotEligible: 'SALE_NOT_ELIGIBLE' as DeclineReasonEnum,
        OnlineshopOrder: 'ONLINESHOP_ORDER' as DeclineReasonEnum
    };
}


